import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { NotSavedInfoMolecule } from '../../molecules';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';

interface LandscapeProjectNotSavedInfoTemplateProps {
  content: string;
}

const LandscapeProjectNotSavedInfoTemplate: FC<
  LandscapeProjectNotSavedInfoTemplateProps
> = ({ content }) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeEditProjectsAddProjectTemplate>
          <NotSavedInfoMolecule content={content} />
        </LandscapeEditProjectsAddProjectTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeProjectNotSavedInfoTemplate;
